/*******************************************************************************
 * @ngdoc    object
 * @module   csm.books.InitialSetup.services
 * @name     csm.books.InitialSetup.services.Data.type:SetupBankAccount
 * @constructor
 * @param {object=} info  Item info read from database.
 * @description
 * Bank Account Information for Initial Setup.
 *******************************************************************************/
/* @ngInject */ export function setupBankAccountConfig(TypeFactoryProvider) {
  /*------------------------------------------*/
  /* Using defaults rather than prototype to  */
  /* make sure default values get serialized. */
  /*------------------------------------------*/
  var defaults = {
    lastStmtBalance: 0, // Last Statement Balance
    pendingItems: [], // Outstanding Items
    isSavings: false, // Savings Account Flag
    lastStmtDate: null // Last statement date.
  };

  TypeFactoryProvider.addType({
    name: 'Data.SetupBankAccount',
    inherits: 'Data.SetupAccount',
    $type: 'csm.books.data.setup.SetupBankAccount, CSMBooks',
    constructor: function (Data, SERVER) {
      return function (data) {
        /*----------------------------------------*/
        /* Instantiate defaults for serialization */
        /* and restore any missing static values. */
        /*----------------------------------------*/
        Data.SetupAccount.call(
          this,
          Object.assign({}, defaults, data, {
            accountClass: SERVER.BooksDBConstants.AC_ASSET,
            side: SERVER.BooksDBConstants.AS_DEBIT,
            type: SERVER.AccountTypes.BANK
          })
        );

        this.pendingItems = (this.pendingItems || []).map(function (p) {
          return new Data.OutstandingBankItem(p);
        });
      };
    }
  });
};
